import gql from 'graphql-tag';
import React, { Fragment, useState } from 'react';
import { withApollo } from 'react-apollo';
import appleIcon from '../../images/apple-app-store.svg';
import googleIcon from '../../images/android-app-store.svg';
import callIcon from '../../images/request-call.svg';
import emailIcon from '../../images/email-to.svg';
import { Link, useLocation } from 'react-router-dom';
import SignUpCallRequest from './SignUpCallRequest';
import TorontoFooter from '../Layout/TorontoFooter';

const DownloadApp = ({ client }) => {
  const location = useLocation();
  const user = location.user;
  const country = location.country;

  const [ticket, setTicket] = useState();
  const [call, setCall] = useState();
  const [isCall, setIsCall] = useState();

  const CREATE_TICKET = gql`
    mutation CallRequestCallback(
      $userId: ID
      $firstName: String
      $lastName: String
      $mobile: String
      $email: String
      $operatingCity: String
    ) {
      callRequestCallback(
        userId: $userId
        firstName: $firstName
        lastName: $lastName
        mobile: $mobile
        email: $email
        operatingCity: $operatingCity
      ) {
        ticket {
          id
        }
        error
      }
    }
  `;

  const CALL_REQUEST = gql`
    mutation StartCallRequest($ticketId: ID!) {
      startCallRequest(ticketId: $ticketId) {
        callRequest {
          id
        }
        success
        error
      }
    }
  `;

  const handleCallRequest = ticketId => {
    // e.preventDefault();
    client
      .mutate({
        mutation: CALL_REQUEST,
        variables: {
          ticketId: ticketId
        }
      })
      .then(res => {
        if (res.data.startCallRequest.success) {
          setCall(res.data.startCallRequest.callRequest.id);
          toggleCall();
          console.log('Call requested');
        }
      });
  };

  const handleCreateTicket = e => {
    // e.preventDefault();
    client
      .mutate({
        mutation: CREATE_TICKET,
        variables: {
          userId: user && user.id,
          firstName: null,
          lastName: null,
          mobile: null,
          email: null,
          operatingCity: null
        }
      })
      .then(res => {
        if (!res.data.callRequestCallback.error) {
          handleCallRequest(res.data.callRequestCallback.ticket.id);
          setTicket(res.data.callRequestCallback.ticket.id);
          console.log('Ticket created, starting a call request...');
        }
      });
  };

  const toggleCall = () => {
    setIsCall(!isCall);
  };

  const emailTo = {
    pathname: '/signup/email',
    user: user && user
  };

  return (
    <Fragment>
      {isCall ? (
        <SignUpCallRequest ticketId={ticket} requestId={call} />
      ) : (
        <div className="signup-form-container">
          <div className="download-title">
            Welcome, {user && user.firstName}
          </div>
          <div>User ID: {user && user.id}</div>
          <div className="download-sub-title">
            Next step: Download the app
          </div>
          <div className="download-description">
            Thank you for signing up. Please download the app and log in
            using the email and password you just created to continue with
            the application process.
          </div>
          <div style={{ margin: '24px 0 60px 0' }}>
            You can get additional support and chat with our team through
            the app.
          </div>

          <div
            className="app-link-container"
            style={{ alignItems: 'center', width: '300px' }}>
            <a
              href={
                country === 'CA'
                  ? 'https://apps.apple.com/ca/app/autzu/id1486349150?mt=8'
                  : 'https://apps.apple.com/us/app/autzu/id1486349150?mt=8'
              }
              className="apple-store-link"
              target="_blank">
              <img src={appleIcon} />
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.autzu.autzuAndroid&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
              className="play-store-link"
              target="_blank">
              <img alt="Get it on Google Play" src={googleIcon} />
            </a>
          </div>
          <div className="download-sub-title">Have a question?</div>
          <div style={{ margin: '24px 0 60px 0' }}>
            View the answers to{' '}
            <Link
              to="/tor/faq"
              target="_blank"
              style={{ color: '#128dff' }}>
              FAQ here
            </Link>{' '}
            or contact us by choosing one of the options below.
          </div>
          <div className="options-container">
            <Link
              to={emailTo}
              style={{ color: '#414141', textDecoration: 'none' }}>
              <div className="option-box">
                <img src={emailIcon} style={{ marginBottom: '12px' }} />
                <div>
                  Send us an email and we will get back to you in 24 hours.
                </div>
              </div>
            </Link>
            <div
              className="option-box"
              onClick={() => {
                handleCreateTicket();
              }}>
              <img src={callIcon} style={{ marginBottom: '12px' }} />
              <div>
                Request a call and join the waitlist. We will call you as
                soon as possible.
              </div>
            </div>
          </div>
        </div>
      )}
      <TorontoFooter />
    </Fragment>
  );
};

export default withApollo(DownloadApp);



// WEBPACK FOOTER //
// ./src/components/NewSignUp/DownloadApp.js